import { TranslatableEntity } from '~/app/core/models/translatable-entity';
import { ExternalFile } from '../../../shared/components/external-file/models/external_file';
import { convertMentionHTML } from '../../../shared/helpers/dom';
import { StripTagsPipe } from '../../../shared/pipes/strip-tags.pipe';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';
import { Context } from '../../mgmt/context/models/context';
import { User } from '../../mgmt/user/models/user';
import { Tag } from '../feed-tag/models/tag';
import { Author } from './author';
import { FeedPostType } from './feed-post-type';
import { PostLanguage } from './post-language';
import { MediaFile } from '~/app/shared/components/filemanager/models/media-file';

export class FeedPost extends TranslatableEntity<FeedPost, PostLanguage> {
  public titleTranslated?: string;
  public descriptionTranslated?: string;
  public teaser?: string;

  to?: string;
  from?: string;
  author: Author = new Author();
  tags: Tag[] = [];
  type: FeedPostType = new FeedPostType();
  bookmarked = false;
  likeCount = 0;
  liked = false;
  enableLikes = true;
  enableComments = true;
  video = '';
  views = 0;
  approved = true;
  teaserPicture?: MediaFile | null;
  coordinates?: {
    longitude?: number;
    latitude?: number;
  };
  s3Video?: ExternalFile | null;
  s3Image?: ExternalFile | null;
  s3VideoThumbnail?: ExternalFile | null;
  contexts: Context[] = [];
  mentionedUsers?: Array<User>;
  isTeaserShortened = false;
  public override deserialize(object: this): this {
    object.tags = object.tags ? object.tags.map((item) => new Tag().deserialize(item)) : [];
    object.languages = object.languages ? object.languages.map((item) => new PostLanguage().deserialize(item)) : [];
    object.contexts = object.contexts ? object.contexts.map((item) => new Context().deserialize(item)) : [];
    object.mentionedUsers = object.mentionedUsers
      ? object.mentionedUsers.map((item) => new User().deserialize(item))
      : [];

    return super.deserialize(object);
  }

  public updateTranslations(): void {
    const translation = this.getPropertyTranslation(this.translatedEntities, 'title', 'teaser', 'description');
    this.titleTranslated = translation?.title?.toString() ?? '';
    this.descriptionTranslated = convertMentionHTML(
      this.mentionedUsers ?? [],
      translation?.description?.toString() ?? '',
    );
    this.teaser = translation?.teaser
      ? translation.teaser.toString()
      : translation?.description
        ? new TruncatePipe().transform(
            new StripTagsPipe().transform(translation.description.toString(), ['img', 'video']),
            300,
          )
        : '';
  }

  public getTeaser(maxLength: number) {
    if (this.teaser?.length && this.teaser.length <= maxLength) return this.teaser;
    else {
      this.isTeaserShortened = true;
      const lastspace = this.teaser?.lastIndexOf(' ', maxLength);
      if (lastspace != -1) {
        this.teaser = this.teaser?.slice(0, lastspace);
      }
      this.teaser += '...';
      return this.teaser;
    }
  }
}
